import { Container } from '@twistopayments/design-system/components/atoms/container'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { SectionsOurVisionComponent } from '@twisto/api-cms'

import * as styles from './our-vision.styles'

export const OurVision = ({
  title,
  subtitle,
  items,
}: SectionsOurVisionComponent) => (
  <section css={styles.section}>
    <Container size="wider">
      <Typography align="center" color="primary" fontWeight="heavy">
        {subtitle}
      </Typography>
      <Typography align="center" fontWeight="heavy" variant="h1">
        {title}
      </Typography>

      {items && (
        <ul css={styles.itemsContainer}>
          {items.map(({ text, headline, id }) => (
            <li key={id} css={styles.item}>
              <Typography css={styles.itemHeadline}>{headline}</Typography>
              <Typography>{text}</Typography>
            </li>
          ))}
        </ul>
      )}
    </Container>
  </section>
)
